module.exports = __webpack_public_path__ + "img/ic-playlists-inactive.4e7f5ad6.svg";